import React from "react";

// Entegrasyon arama kutusu (pill input + arama ikonu).
export default function IntegrationSearch({ value, onChange, placeholder = "Entegrasyon ara..." }) {
    return (
        <div className="position-relative" style={{ minWidth: 240 }}>
            <i
                className="bx bx-search position-absolute"
                style={{ left: 14, top: "50%", transform: "translateY(-50%)", color: "#9aa2b1", fontSize: 18 }}
            />
            <input
                type="text"
                className="form-control shadow-sm border-0"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                style={{ borderRadius: 999, padding: ".55rem 1rem .55rem 2.4rem" }}
            />
        </div>
    );
}
